module.exports = __webpack_public_path__ + "static/media/wordsmith.6ff433d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/img/wordsmith.jpg
// module id = 125
// module chunks = 0